<template>
  <div class="easyBookingIcon">
    <div class="easyBookingIcon__circle text-center align-center">
      <div class="easyBookingIcon__smallCircle" :style="`background-color: ${primaryColor};`" />
      <div class="easyBookingIcon__bigCircle" :style="`background-color: ${primaryColor}; filter: brightness(115%);`" />

      <svg
        data-v-fae5bece=""
        viewBox="0 0 42 47"
        class="easyBookingIcon__image"
        :style="`fill: ${backgroundColor};`"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          data-v-fae5bece=""
          d="M190.86 177.76v7h-6v-7c-3.12 0-5 2.74-5 6v2a6.23 6.23 0 004 6v27a4 4 0 008 0v-27a6.23 6.23 0 004-6v-2c0-3.26-1.86-6-5-6z"
          transform="translate(-178.86 -176.76)"
          style="fill: rgb(255, 255, 255)"
        />
        <path data-v-fae5bece="" d="M9 40v2" class="cls-1" style="fill: rgb(255, 255, 255)" />
        <path
          data-v-fae5bece=""
          d="M 193.86 211.76 L 213.86 211.76 C 215.517 211.76 216.86 210.417 216.86 208.76 L 216.86 202.76 C 216.883 202.336 216.825 201.912 216.69 201.51 L 215.69 199.94 C 215.311 199.365 215.613 198.589 216.28 198.42 L 218.9 197.76 C 219.452 197.76 219.9 197.312 219.9 196.76 L 219.9 194.76 C 219.9 194.208 219.452 193.76 218.9 193.76 L 214.4 193.76 C 214.062 193.758 213.746 193.928 213.56 194.21 L 212.24 196.21 C 211.285 197.043 210.71 197.513 208.86 197.78 L 193.86 197.78"
          transform="translate(-178.86 -176.76)"
          style="fill: rgb(255, 255, 255)"
        />
        <path
          data-v-fae5bece=""
          d="M 215.86 210.76 L 215.86 214.76 C 215.86 215.312 215.412 215.76 214.86 215.76 L 207.86 215.76 C 207.308 215.76 206.86 215.312 206.86 214.76 L 206.86 211.76"
          style="fill: rgba(255, 255, 255, 0.6)"
          transform="translate(-178.86 -176.76)"
        />
        <path data-v-fae5bece="" d="M15 31h13" style="fill: rgba(255, 255, 255, 0.9)" />
        <path
          style="fill: rgba(255, 255, 255, 0.77); stroke-linecap: round; stroke-width: 0px; stroke-linejoin: bevel"
          d="M 17.258 9.909 C 18.77 9.897 27.589 9.671 29.269 10.909 C 30.949 12.147 32.821 16.91 33.161 17.936 C 33.562 19.146 32.018 20.638 29.203 20.624 C 27.156 20.614 17.176 20.642 15.017 20.623 L 15.055 14.183 C 15.055 14.183 16.219 13.207 16.661 12.261 C 17.146 11.224 17.258 9.909 17.258 9.909 Z"
        />
      </svg>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EasyBookingIcon',
  props: {
    primaryColor: String,
    backgroundColor: String
  }
};
</script>

<style scoped lang="scss">
@import '@/assets/scss/_variables.scss';
.easyBookingIcon {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  max-height: 100px;

  &__circle {
    position: relative;
    width: 220px;
    height: 220px;
    transform: scale(0.4);
  }

  &__bigCircle {
    position: absolute;
    display: block;
    background: $primaryColor;
    border-radius: 50%;
    opacity: 0.85;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 3;
  }

  &__smallCircle {
    position: absolute;
    width: 135px;
    height: 135px;
    right: -35px;
    top: -35px;
    background: $primaryColor;
    border-radius: 50%;
    opacity: 1;
    z-index: 2;
  }

  &__image {
    position: relative;
    width: 95px;
    top: 50%;
    left: 0%;
    transform: translate(0%, -50%);
    z-index: 4;
    fill: $lightest;
  }

  @media (max-width: 960px) {
    & {
      margin-top: 25px;
    }
  }

  @media (min-width: 960px) {
    & {
      min-height: 100%;
      height: 430px;
      border-right: 1px solid rgba(151, 151, 151, 0.31);
    }

    &__circle {
      transform: scale(1);
    }
  }
  @media (min-width: 960px) and (max-width: 1264px) {
    & {
      padding-right: 60px;
    }
  }
}
</style>

